import { render } from "./returnRule.vue?vue&type=template&id=c7275778&scoped=true"
const script = {}

import "./returnRule.vue?vue&type=style&index=0&id=c7275778&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7275778"]])

export default __exports__